import headerImage from './img/0-mbednarz.jpg';
import { StyledImage } from '../styled';

export default () => {
    return (
    <StyledImage 
        src={headerImage} 
        alt='black and white two-third portrait 
            of a white male with glasses and facail hair 
            on a light drape background'
        />
    )
}
